import { isNullOrUndefined } from '@vy/utils';

import { TaxRateMode } from '../../customers-component/tax-rate-mode';

export function getCustomerTaxTypeLabel(taxRate: number | null | undefined): TaxRateMode {
  return isNullOrUndefined(taxRate) ? TaxRateMode.AUTO : TaxRateMode.MANUAL;
}
